import { useEffect, useState } from 'react'

const getOnline = () => (typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean' ? true : navigator.onLine)

// navigator.onLine reliably reports "no network"; true only means a network exists, not that the API is reachable.
export default function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(getOnline)

    useEffect(() => {
        const update = () => setIsOnline(getOnline())
        update()
        window.addEventListener('online', update)
        window.addEventListener('offline', update)
        return () => {
            window.removeEventListener('online', update)
            window.removeEventListener('offline', update)
        }
    }, [])

    return isOnline
}
